import React, { useId, useState } from 'react';
import './AnalyticsMobile.css';

// Keep filter state mounted when collapsed; desktop always displays the controls.
export default function AnalyticsFilters({ children, label = 'Filters', className = '', summary = '', action }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return <div className={`analytics-filter-panel ${open ? 'is-open' : ''}`}>
    <button type="button" className="analytics-filter-toggle" aria-expanded={open} aria-controls={id} onClick={() => setOpen(value => !value)}>{label}<span>{summary}</span><span aria-hidden="true">{open ? '−' : '+'}</span></button>
    {action && <button type="button" className="analytics-show-all" onClick={action.onClick}>{action.label}</button>}
    <div id={id} className={`analytics-filter-content ${className}`}>{children}</div>
  </div>;
}
